(function() {
  'use strict';
  if (window.__gmHeaderNavBooted) return;
  window.__gmHeaderNavBooted = true;

  function closeNav(wrap) {
    if (!wrap) return;
    wrap.classList.remove('is-open');
    var toggle = wrap.querySelector('[data-gm-header-nav-toggle]');
    var backdrop = document.querySelector('[data-gm-header-nav-backdrop]');
    var menu = document.getElementById('gm-header-nav-menu');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
    }
    if (menu && menu.parentElement === document.body) {
      wrap.appendChild(menu);
    }
    if (backdrop) {
      backdrop.hidden = true;
      if (backdrop.parentElement === document.body) {
        wrap.insertBefore(backdrop, menu);
      }
    }
    if (!document.querySelector('[data-gm-header-nav-wrap].is-open')) {
      document.body.classList.remove('gm-nav-drawer-open');
    }
  }

  function openNav(wrap) {
    if (!wrap) return;
    wrap.classList.add('is-open');
    var toggle = wrap.querySelector('[data-gm-header-nav-toggle]');
    var backdrop = wrap.querySelector('[data-gm-header-nav-backdrop]');
    var menu = document.getElementById('gm-header-nav-menu');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
    }
    if (backdrop) {
      backdrop.hidden = false;
      document.body.appendChild(backdrop);
    }
    if (menu) {
      document.body.appendChild(menu);
    }
    document.body.classList.add('gm-nav-drawer-open');
  }

  function resetDesktopNav() {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    document.querySelectorAll('[data-gm-header-nav-wrap]').forEach(closeNav);
  }

  function initHeaderNav() {
    document.querySelectorAll('[data-gm-header-nav-wrap]').forEach(function(wrap) {
      if (wrap.dataset.gmHeaderNavInit) return;
      wrap.dataset.gmHeaderNavInit = '1';

      var toggle = wrap.querySelector('[data-gm-header-nav-toggle]');
      var menu = wrap.querySelector('.gm-header-nav');
      if (!toggle || !menu) return;

      var backdrop = wrap.querySelector('[data-gm-header-nav-backdrop]');
      var closeBtn = wrap.querySelector('[data-gm-header-nav-close]');

      toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        if (wrap.classList.contains('is-open')) closeNav(wrap);
        else openNav(wrap);
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          closeNav(wrap);
        });
      }

      if (backdrop) {
        backdrop.addEventListener('click', function() {
          closeNav(wrap);
        });
      }

      menu.querySelectorAll('.gm-header-nav-link').forEach(function(link) {
        link.addEventListener('click', function() {
          closeNav(wrap);
        });
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-gm-header-nav-wrap].is-open').forEach(closeNav);
    });

    window.addEventListener('resize', function() {
      if (window.matchMedia('(min-width: 750px)').matches) {
        document.querySelectorAll('[data-gm-header-nav-wrap].is-open').forEach(closeNav);
      }
    });

    resetDesktopNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderNav);
  } else {
    initHeaderNav();
  }
})();
